module.exports = __webpack_public_path__ + "media/images/lb/369-e7e191683987fa8d07efd61514137fd6.svg";